const getDefaultState = () => {
  return {
    show: false,
    title: "",
    content: "",
    alert: false,
    error: false,
    button: "",
    buttons: [],
    redirectPathName: "",
    outerLink: "",
    action: null
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_SHOW: (state, show) => {
    state.show = show;
  },
  SET_TITLE: (state, title) => {
    state.title = title;
  },
  SET_CONTENT: (state, content) => {
    state.content = content;
  },
  SET_ALERT: (state, alert) => {
    state.alert = alert;
  },
  SET_ERROR: (state, error) => {
    state.error = error;
  },
  SET_BUTTON: (state, button) => {
    state.button = button;
  },
  SET_BUTTONS: (state, buttons) => {
    state.buttons = buttons;
  },
  SET_REDIRECTPATHNAME: (state, redirectPathName) => {
    state.redirectPathName = redirectPathName;
  },
  SET_OUTERLINK: (state, outerLink) => {
    state.outerLink = outerLink;
  },
  SET_ACTION: (state, action) => {
    state.action = action;
  },
  RESET: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  //show snackbar
  show(
    { commit, dispatch },
    {
      title = "",
      content = "",
      alert = false,
      error = false,
      button = "",
      buttons = null,
      redirectPathName = "",
      outerLink = "",
      action = null
    }
  ) {
    commit("SET_SHOW", true);
    commit("SET_TITLE", title);
    commit("SET_CONTENT", content);
    commit("SET_ALERT", alert);
    commit("SET_ERROR", error);
    commit("SET_BUTTON", button);
    commit("SET_BUTTONS", buttons);
    commit("SET_REDIRECTPATHNAME", redirectPathName);
    commit("SET_OUTERLINK", outerLink);
    commit("SET_ACTION", action);
    document.documentElement.style.overflow = "hidden";
    document.body.scroll = "no";
    if (alert) {
      setTimeout(() => {
        dispatch("close");
      }, 2000);
    }
  },
  close({ commit }) {
    document.documentElement.style.overflow = "scroll";
    document.body.scroll = "yes";
    commit("SET_SHOW", false);
    setTimeout(() => {
      commit("RESET");
    }, 300);
  }
};

const getters = {
  dialog: state => state
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
